import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";
const { mobileFirstCss } = mediaQueryStyles;

export const ACTIONS_TOOLBAR_HEIGHT = "76px";
export const SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT = "155px";
export const ACTIVITY_PANEL_ASSIGN_HEIGHT = "90px";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const actionsToolbarCss = mobileFirstCss({
  display: "flex",
  maxHeight: [
    SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT,
    SMALL_SCREEN_ACTIONS_TOOLBAR_HEIGHT,
    ACTIONS_TOOLBAR_HEIGHT,
  ],
  paddingLeft: ["14px", "14px", "20px"],
  paddingTop: "20px",
  paddingRight: ["14px", "14px", "20px"],
  paddingBottom: "20px",
  rowGap: ["14px", "22px"],
});

export const assignStatusAndStudentViewCss = mobileFirstCss({
  display: "flex",
  flexDirection: ["column", "row"],
  columnGap: [0, "20px"],
  rowGap: "14px",
  width: "100%",
});

export const assignAndStatusWrapperCss = {
  display: "flex",
  flexBasis: "content",
  width: "100%",
  columnGap: "8px",
};

export const assignmentActionsWrapperCss = {
  display: "flex",
  gap: "10px",
};

export const studentViewCss = mobileFirstCss({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const languageLexileAndStudentWrapperCss = mobileFirstCss({
  display: "flex",
  flexDirection: ["column-reverse", "row"],
  columnGap: ["initial", "initial", "17px", "20px"],
});

export const languageAndLexileWrapperCss = mobileFirstCss({
  display: "flex",
});

export const assignPrintAndMoreWrapperCss = mobileFirstCss({
  display: "flex",
  alignItems: "center",
  columnGap: ["initial", "initial", "8px", "12px"],
});

export const showForMobileCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "normal",
  alignItems: "start",
  columnGap: "8px",
  rowGap: "14px",
  width: "100%",

  [breakpoint.downTo("sm")]: {
    display: "none",
  },
};

export const showForDesktopCss: CSSObject = {
  display: "none",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  columnGap: "8px",
  width: "100%",

  [breakpoint.downTo("sm")]: {
    display: "flex",
  },
};
